import Cookies from "js-cookie";

// 登录凭据与用户身份信息统一存 cookie（键名与现行一致，保证升级期兼容）
const KEYS = {
  token: "vue_token",
  level: "level",
  userName: "UserName",
  userId: "UserId",
  companyName: "CompanyName",
  companyCode: "CompanyCode",
};

function makeAccessor(key) {
  return {
    get: () => Cookies.get(key),
    set: (v) => Cookies.set(key, v),
    remove: () => Cookies.remove(key),
  };
}

const entries = Object.fromEntries(
  Object.entries(KEYS).map(([name, key]) => [name, makeAccessor(key)])
);

export const getToken = entries.token.get;
export const setToken = entries.token.set;
export const removeToken = entries.token.remove;

export const getLevel = entries.level.get;
export const setLevel = entries.level.set;
export const removeLevel = entries.level.remove;

export const getUserName = entries.userName.get;
export const setUserName = entries.userName.set;
export const removeUserName = entries.userName.remove;

export const getUserId = entries.userId.get;
export const setUserId = entries.userId.set;
export const removeUserId = entries.userId.remove;

export const getCompanyName = entries.companyName.get;
export const setCompanyName = entries.companyName.set;
export const removeCompanyName = entries.companyName.remove;

export const getCompanyCode = entries.companyCode.get;
export const setCompanyCode = entries.companyCode.set;
export const removeCompanyCode = entries.companyCode.remove;
